module.exports = __webpack_public_path__ + "img/img-88.532578b6.png";